import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {EcorealCtSharedModule} from "../../../../shared/shared.module";
import {TranslateDirective, TranslateService} from "@ngx-translate/core";
import {Tree} from "primeng/tree";
import {CommonModalComponent} from "../../../../shared/common-modal/common-modal.component";
import {
  AssociateOptionCategoryPayload,
  AssociateOptionPayload,
  CubicleOption,
  EditCategoryPayload
} from "../../../../shared/model/cubicleOption-model";
import {TreeNode} from "primeng/api";
import {SwitchBoardComponent} from "../../../../configuration/shared/model/component";
import {MultiSelect} from "primeng/multiselect";
import {NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {OptionsService} from "../../../../shared/services/options.service";
import {forkJoin} from "rxjs";
import {
  EditCategoryForm,
  OdmOptionSelectCategoryComponent
} from "./odm-option-select-category/odm-option-select-category.component";
import {Category} from "../../../../configuration/shared/model/IProduct";
import {ComponentService} from "../../../../configuration/shared/services/component.service";

@Component({
  selector: 'app-odm-associate-option-modal',
  imports: [
    EcorealCtSharedModule,
    TranslateDirective,
    Tree,
    MultiSelect,
    NgIf,
    FormsModule,
    OdmOptionSelectCategoryComponent
  ],
  templateUrl: './odm-associate-option-modal.component.html',
  styleUrl: './odm-associate-option-modal.component.scss'
})
export class OdmAssociateOptionModalComponent {
  @ViewChild('associateOptionModal', {static: false}) copyOptionModal: CommonModalComponent;
  @ViewChild('confirmationModal') confirmationModal: CommonModalComponent;
  @ViewChild('dt') dt: any;

  @Input()
  rangeId: string;
  @Output()
  associateOption: EventEmitter<AssociateOptionPayload> = new EventEmitter<AssociateOptionPayload>();

  @Output()
  deleteCategoryAssociation: EventEmitter<AssociateOptionCategoryPayload> = new EventEmitter<AssociateOptionCategoryPayload>();

  availableOptions: CubicleOption[];
  availableComponents: SwitchBoardComponent[];
  availableCategories: Category[];

  selectedOptions: CubicleOption[];
  selectedComponents: SwitchBoardComponent[];

  resultComponents: SwitchBoardComponent[];

  isDeletePreview: boolean = false;
  deleteCategoryPayload: AssociateOptionCategoryPayload | null = null;
  deleteCategoryName = '';

  category: EditCategoryPayload;
  treeDataOption: TreeNode[] = [];
  treeDataResultComponents: TreeNode[] = [];
  modalTitle = '';

  constructor(private readonly translateService: TranslateService,
              private readonly optionsService: OptionsService,
              private readonly componentService: ComponentService) {
  }


  hide() {
    this.copyOptionModal.hide();
  }

  show() {
    this.resetFields();
    forkJoin([
      this.optionsService.getOptionsElementsByRangeId(this.rangeId),
      this.componentService.getPublishedComponentsByRangeId(this.rangeId)
    ]).subscribe(results => {
      this.availableOptions = results[0];
      this.availableOptions = results[0].filter(opt => this.isValidOption(opt));
      this.availableOptions.forEach(option => {
        option.displayName = this.translateService.instant(option.name);
      });
      this.availableOptions = this.availableOptions.toSorted((a, b) => a.displayName.localeCompare(b.displayName));

      this.availableComponents = results[1].map(component => ({
        ...component, displayName: component.reference?.ref
      })).toSorted((a, b) => (a.displayName) > b.displayName ? 1 : -1);
      this.availableCategories = [...new Map(this.availableComponents.flatMap(comp =>
        comp.options
          .filter(option => option.category !== null && option.category !== undefined)
          .map(option => option.category)
          .map(item => [item.id, item]))).values()]
      this.availableCategories = this.availableCategories.toSorted((a, b) => a.id.localeCompare(b.id));
      this.copyOptionModal.show();
    });

  }

  private resetFields() {
    this.selectedOptions = [];
    this.selectedComponents = [];
    this.category = null;
    this.treeDataOption = [];
  }


  isValidForm(): boolean {
    return this.selectedOptions !== null && this.selectedOptions !== undefined && this.selectedOptions.length > 0&&
      this.selectedComponents !== null && this.selectedComponents !== undefined && this.selectedComponents.length > 0 &&
      this.category !== null;

  }

  clickOnSaveOption() {
    this.associateOption.emit(this.getPayload());
    this.hide();
  }

  onConfirmDelete() {
    this.deleteCategoryAssociation.emit(this.deleteCategoryPayload);
    this.deleteCategoryPayload = null;
    this.isDeletePreview = false;
    this.hide();
  }

  createTreeNodeOptions() {
    this.treeDataOption = [];
    this.selectedOptions.forEach(option => {
      this.createTreeNodeOption(option);
    })
  }

  createTreeNodeOption(option: CubicleOption) {
    this.treeDataOption.push({
      label: this.translateService.instant(option.name),
      expanded: false,
      children: []
    });
    option.values.forEach(value => {
      if (value.reference !== null) {
        this.treeDataOption[this.treeDataOption.length - 1].children.push({
          label: this.translateService.instant(value.reference.ref) + ' - ' + this.translateService.instant(value.value)
        });
      } else {
        this.treeDataOption[this.treeDataOption.length - 1].children.push({
          label: this.translateService.instant(value.value)
        });
      }
    });
  }


  createTreeNodeComponents() {
    this.treeDataResultComponents = [];
    this.resultComponents.forEach(comp => {
      this.treeDataResultComponents.push({
        label: comp.reference.ref,
        expanded: false,
        children: []
      });
      const categoryGroups = Object.groupBy(comp.options, ({category}) => category?.id);
      const categoryIds = [
        'undefined', ...new Set(
          comp.options
            .filter(option => option.category !== null && option.category !== undefined)
            .map(option => option.category?.id)
        )];
      categoryIds.forEach(id => {
        this.treeDataResultComponents.at(-1).children.push({
          label: id !== 'undefined' ? id : '-',
          expanded: false,
          children: []
        });
        if (categoryGroups[id] === null || categoryGroups[id] === undefined) {
          this.treeDataResultComponents.at(-1).children.splice(this.treeDataResultComponents.at(-1).children.length - 1, 1);
          return;
        }
        categoryGroups[id].forEach(option => {
          this.treeDataResultComponents.at(-1).children[this.treeDataResultComponents.at(-1).children.length - 1].children.push({
            label: this.translateService.instant(option.name),
            expanded: false,
            children: []
          });
          option.values.forEach(value => {
            if (value.reference === null) {
              this.treeDataResultComponents.at(-1)
                .children[this.treeDataResultComponents.at(-1).children.length - 1]
                .children[this.treeDataResultComponents.at(-1).children[this.treeDataResultComponents.at(-1).children.length - 1].children.length - 1]
                .children.push({
                label: this.translateService.instant(value.value)
              });
            } else {
              this.treeDataResultComponents.at(-1)
                .children[this.treeDataResultComponents.at(-1).children.length - 1]
                .children[this.treeDataResultComponents.at(-1).children[this.treeDataResultComponents.at(-1).children.length - 1].children.length - 1]
                .children.push({
                label: this.translateService.instant(value.reference.ref) + ' - ' + this.translateService.instant(value.value)
              });
            }
          });
        });
      });
    });
  }


  onCategoryChange(event: EditCategoryForm) {
    this.category = event;
  }

  previewAssociateOptions() {
    this.modalTitle = this.translateService.instant('T_PREVIEW_ASSOCIATION_OPTIONS');
    this.isDeletePreview = false;
    this.optionsService.previewAssociatedOptions(this.getPayload()).subscribe(result => {
        this.resultComponents = result.toSorted((left, right) =>
          left.reference.ref.localeCompare(right.reference.ref, undefined, {
            numeric: true,
            sensitivity: 'base'
          })
        );
        this.createTreeNodeComponents();
        this.confirmationModal.show();
      }
    );
  }

  showDeletePreview(components: SwitchBoardComponent[], payload: AssociateOptionCategoryPayload) {
    this.modalTitle = this.translateService.instant('T_CONFIRM_TITLE');
    this.isDeletePreview = true;
    this.deleteCategoryPayload = payload;
    this.deleteCategoryName = payload.categoryId;
    this.resultComponents = components.map(comp => {
      const categoryName = comp.options.find(opt => opt.category?.id === payload.categoryId)?.category?.name;
      if (categoryName) {
        this.deleteCategoryName = this.translateService.instant(categoryName);
      }

      return {...comp, options: comp.options.filter(opt => opt.category?.id !== payload.categoryId)} as SwitchBoardComponent;
    });
    this.createTreeNodeComponents();
    this.confirmationModal.show();
  }

  private getPayload() {
    return {
      options: this.selectedOptions,
      components: this.selectedComponents.map(component => component.reference.ref),
      rangeId: this.rangeId,
      category: this.category
    };
  }

  private isValidOption(opt: CubicleOption): boolean {
    const values = (opt.values ? opt.values : []).filter(value => value && value.value && value.value.trim().length > 0);
    const hasReference = values.some(value => value.reference && value.reference.ref && value.reference.ref.trim().length > 0);
    const hasOnlyWithoutValue = values.length === 1 && values[0] && values[0].value === 'T_WITHOUT';

    if (values.length === 0 || hasOnlyWithoutValue || !hasReference) {
      return false;
    }

    return !opt.mandatory || values.length >= 2;
  }
}
